<template lang="pug">
.extract

  .title.row.col-s.ac
    .g10.g12-s.letter Extrato 
      strong de Pagamentos
    .g7.g12-s.row.column-s.margin-top-s
      .g5.g12-s
        select.filter.grid-12-s(v-model="status_pagamento" @change="load_extract({ status_pagamento: status_pagamento })")
          option(value="") Filtrar status do pagamento
          option(value="pago") Pago
          option(value="pendente") Pendente
      .g3.g12-s
        input.filter.grid-12-s(type="date" v-model="data_inicio" placeholder="Data incial" @blur="load_extract({ data_inicio: data_inicio, data_fim: data_fim })")
      .g1.hide-s
      .g3.g12-s
        input.filter.grid-12-s(type="date" v-model="data_fim" placeholder="Data final" @change="load_extract({ data_inicio: data_inicio, data_fim: data_fim })")

  .info.col-s
    a(href="/pendencias?pagamento=true" target="_blank") Confira aqui
    |  prazos para emissão de sua nota fiscal e de pagamento.

  .container
    .table.col(v-if="!loader")
      template(v-if="extract.length > 0")
        .col.payment.bw.sh(v-for="(ciclo, i) in extract" :key="'extract' + i")
          
          .br.cw.font-16.fb.tc(v-if="ciclo.notificacao_alerta_nf" style="padding:6px 12px") ATENÇÃO!!! NÃO EMITA NOTA FISCAL ANTECIPADA. AGUARDE A LIBERAÇÃO DO SISTEMA.
          
      
          .row.col-s.total.ac(@click="toggleCycle(ciclo)")
            .previsao.td.tc.g3.g12-s.cp
              b.cp.font-16 CICLO {{ ciclo.tipo_ciclo.toUpperCase() }}
              br
              b.font-12(style="color: #222") PREVISÃO DE PAGAMENTO:
              br
              //- No bimensal (sc-9917) não há janela: a previsão final é a própria previsão, e mostrar
              //- "20/11 a 20/11" só confundiria. Decidido pelo rótulo que a API devolve.
              b(v-if="ciclo.tipo_ciclo == 'Bimensal'") {{ ciclo.dt_previsao_pagamento | date }}
              b(v-else) {{ ciclo.dt_previsao_pagamento | date }} a {{ ciclo.dt_previsao_pagamento_final | date }}
            .g2.g12-s.td.row-s
              .g6-s.g12-s.jc.col.column-s.ac
                div(v-if="ciclo.status_nota_fiscal == 'invalidado'")
                  Button(layout="red-go" @click="modal = { title: 'Nota Fiscal', layout: 'NF', show: true, dt_previsao_pagamento: ciclo.dt_previsao_pagamento, tipo_ciclo: ciclo.tipo_ciclo, description: 'Instruções para emissão.', erro: `<b class='text-red'>Motivo da correção:<br /></b><span class='text-red'>${ciclo.motivo_status_nota_fiscal}</span>`, file: () => { modal.title = 'Anexar Nota Fiscal'; modal.layout = 'Files'; modal.description = '' }, callback: load_extract }" title="Corrigir Nota Fiscal")
                    i.fa.fa-exclamation-triangle
                    |  Corrigir
                  | &nbsp;

                b.text-orange.font-18(v-if="ciclo.status_nota_fiscal == 'pendente'") Em Revisão
                b.text-green.font-18(v-if="ciclo.status_nota_fiscal == 'validado'")
                  i.fa.fa-check
                  |  Validado

                Button(layout="green-go" v-if="ciclo.status_nota_fiscal != 'pendente' && ciclo.status_nota_fiscal != 'invalidado' && ciclo.status_nota_fiscal != 'validado'" :disabled="ciclo.notificacao_alerta_nf" @click="modal = { title: 'Nota Fiscal', layout: 'NF', show: true, dt_previsao_pagamento: ciclo.dt_previsao_pagamento, tipo_ciclo: ciclo.tipo_ciclo, description: 'Instruções para emissão.', file: () => { modal.title = 'Anexar Nota Fiscal'; modal.layout = 'Files'; modal.description = ''; }, callback: load_extract }" title="Fazer upload da nota fiscal")
                  i.fa.fa-upload
                  |  Nota Fiscal
                br
                Button(v-if="ciclo.antecipacao_liberada" layout="green-go" @click="modalAntecipacao.show = true" style="margin-top:10px" title="Antecipação de pagamento") Antecipação
            .g2.g12-s.td.row-s
              label.g6 Jobs
              .g6-s
                span R$
                |  {{ ciclo.total_atendimento_ciclo.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.row-s
              label.g6 Horas adicionais
              .g6-s
                span R$
                |  {{ ciclo.total_horas_extras_ciclo.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.row-s
              label.g6 Reembolso
              .g6-s
                span R$
                |  {{ ciclo.total_reembolso_ciclo.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.row-s.tot
              label.g6 Total
              .g6-s.font-18.cg
                span R$
                |  {{ ciclo.total_geral_ciclo.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}

          .row.hide-s( v-if="ciclo.show")
            .g1.th ID
            .g2.th Data do Encerramento
            .g2.th Valor (R$)
            .g2.th Horas adicionais (R$)
            .g2.th Reembolso (R$)
            .g2.th Total (R$)
            // .g2.th.tc Nota Fiscal
          .row.sub.col-s(v-for="(job, j) of ciclo.jobs" :key="'job-' + j" v-if="ciclo.show")
            .g1.td.col-s
              span.hide-m.hide-g JOB
              b {{ job.id_job }}
            .g2.g12-s.td.col-s
              span.hide-m.hide-g.grid-6 Data do Encerramento
              b {{ new Date(job.dh_ult_encerramento).toLocaleString() }}
            .g2.g12-s.td.col-s
              .hide-m.hide-g.grid-6 Valor do Job (R$)
              b.g6-s
                | R$
                |  {{ job.total_atendimento_job.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.col-s
              .hide-m.hide-g.grid-6 Horas adicionais (R$)
              .g6-s
                | R$
                |  {{ job.total_horas_extras_job.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.col-s
              .hide-m.hide-g.grid-6 Reembolso (R$)
              .g6-s
                | R$
                |  {{ job.total_reembolso_job.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            .g2.g12-s.td.col-s
              .hide-m.hide-g Total (R$)
              b.g6-s.totalJob
                span.font-12 R$
                |  {{ job.total_geral_job.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) }}
            //.g2.td.row-s
              .hide-m.hide-g.grid-6
              .g6-s
  .extract-loader.col.ac.jc(v-if="loader")
    Loader
  Telegram
  Modal(:modal="modal")
  Modal(:modal="modalAntecipacao")
    .row.ac.col-s(style="padding: 0 30px")
      .msg.g9 No intuito de fornecer as melhores condições para os nossos 
        b Parceiros
        | , firmamos uma parceria com a 
        b PRAJÁ
        | , uma plataforma de antecipação de recebíveis para facilitar a antecipação dos seus recebimentos.
        p
          | A partir de agora, você pode solicitar a antecipação de pagamentos diretamente pela plataforma da Prajá, de forma simples e rápida.
          |  Na prática, isso significa que você não precisa mais esperar o prazo padrão para receber pelos serviços realizados. Você pode escolher antecipar os valores e ter acesso ao dinheiro antes da data prevista, ajudando no seu fluxo de caixa e organização financeira.
        | Todo o processo é feito online, com transparência e autonomia para você escolher quando deseja antecipar.
        br
        br
        | Confira as condições e realize sua antecipação clicando no botão 
        b Solicitar Antecipação.
      .col.g3.g10-s.ja.ac(style="padding-top:20px")
        img(src="@/assets/img/logo.png" style="width: 175px;height: 40px;")
        img(src="@/assets/img/praja.svg" style="width: 175px")
    .row.jc.ac.col-s(style="padding: 20px 30px;")
      a(:href="user.link_antecipacao" target="_blank" style="margin-top: 10px")
        Button(layout="green-go") Solicitar Antecipação
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Telegram from "@/components/Telegram";
import Button from "@/components/Button";
import Modal from "@/components/Modal";

export default {
  name: "Extract",
  components: { Loader, Telegram, Button, Modal },
  data() {
    return {
      loader: true,
      status_pagamento: "",
      data_inicio: "",
      data_fim: "",
      allow: false,
      file: { name: "", percentLoaded: 0 },
      modalFiles: {
        show: false,
        layout: "Files",
        title: "Anexar Nota Fiscal",
        callback: this.load_extract,
      },
      modal: { ...this.modalFiles },
      modalAntecipacao: {
        show: false,
        title: "ANTECIPAÇÃO DE PAGAMENTO"
      }

    };
  },
  methods: {
    ...mapActions("user", ["LOAD_EXTRACT"]),
    uploadNF(id) {
      document.getElementById("nf" + id).click();
    },
    toggleCycle(ciclo) {
      this.$set(ciclo, "show", !ciclo.show);
    },
    load_extract(filter) {
      this.loader = true;
      this.LOAD_EXTRACT(filter)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("extract");
    this.load_extract();
  },
  computed: {
    ...mapGetters("user", ["user", "extract"]),
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.extract
  .title 
    font-size: 30px
    @media (max-width: $small)
      padding: 10px
      text-align: center
    .letter 
      color: $font-color
      strong 
        color: $supporter-1
  .container
    margin-top: 16px
    max-height: 74vh
    overflow: auto
    @media (max-width: $small)
      padding: 0px 8px

.previsao
  background: rgba($orange-1, .2)
  font-size: 15px
.payment
  border: 1px solid #ddd
  border-bottom: 3px solid #ddd
  border-radius: 12px
  overflow: hidden
  margin-top: 20px
  &:hover
    border: 2px solid $blue-1    
    cursor: pointer
  label
    font-size: 13px
    color: $purple
  .total
    font-size: 16px
    span
      font-size: 12px
  .sub
    background: #fcfcfc
    @media (max-width: $small)
      border-bottom: 1px solid #ddd
      border-radius: 4px
      margin-top: 7px
      background: #fff
    .totalJob
      color: $green-7
      font-size: 17px
  .td label
    @media (max-width: $small)
      padding-left: 12px
.msg
  background: #eee
  border-radius: 12px
  padding: 14px
  margin-right: 15px
a:hover
  color: $purple
</style>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.extract {

  .info {
    padding: 10px 0px;
    color: $red-1;

    @media(max-width: $small) {
      text-align: center;
      margin-top: 20px;
    }

    a {
      background: $purple;
      color: white;
      border-radius: 12px;
      padding: 10px 20px
    }
  } 

  &-empty {
    height: 45vh;
    &-text {
      margin-top: 28px;
      font-size: 18px;
      color: $gray-1;
      text-align: center;
    }
  }

  &-loader {
    height: 35vh;
  }

  &-list {
    padding-bottom: 35px;
    overflow: auto;
  }

  .table {
    padding-right: 20px;
    color: $gray-6;
    font-size: 14px;
    width: 98%;
    margin-top: 15px;

    .job {
      font-weight: bold;
    }

    .td, .th {
      padding: 10px;
      
    }

    .th {
      background: rgba($gray-4,.2);
      color: #222
    }
  }

  .margin-top-s {
    @media (max-width: $small) {
      margin-top: 1.5rem;
    }
  }

}
</style>
